import { useState } from 'react';
import { UseFormRegisterReturn, UseFormSetValue } from 'react-hook-form';

type RatingProps = {
  amount: number;
  selected: number | undefined;
  register: UseFormRegisterReturn;
  // eslint-disable-next-line
  setValue: UseFormSetValue<any>;
};

export const Rating = ({
  amount,
  selected,
  register,
  setValue,
}: RatingProps) => {
  const [rating, setRating] = useState<number | undefined>(selected);
  return (
    <div className="flex items-center">
      <p className="text-2xl font-bold">RATING</p>
      <div className="border w-full border-default mx-8" />
      <div className="flex">
        {[...Array(amount)].map((_, index) => {
          const val = index + 1;
          return (
            <div
              key={val}
              className={`border-default border-2 h-6 w-6 m-1 rounded-full cursor-pointer ${
                rating === val && 'bg-accent'
              }`}
              onClick={() => {
                setRating(val);
                setValue('rating', val);
              }}
            />
          );
        })}
      </div>
      <input {...register} value={rating} type="hidden" />
    </div>
  );
};
